/**
 * @file asset-download.js
 */
(function($) {
  'use strict';

  if ( $('.component--asset-download-callout').length > 0 ) {

    let $trigger = $("[id=ddlAsset]");
    let $triggerText = $("[id=ddlAsset] span");
    let $form = $("[id=formAside]");

    function downloadToggle(e) {
      e.preventDefault();

      if ( $trigger.hasClass('open') ) {
        $triggerText.text('Download');
        $trigger.removeClass('open').attr('aria-expanded', 'false');
        $form.slideUp('fast');
      } else {
        $triggerText.text('Cancel');
        $trigger.addClass('open').attr('aria-expanded', 'true');
        $form.slideDown('fast');
      }
    }

    $trigger.on('click', downloadToggle);

    $(document).ajaxComplete(function(event, xhr, settings) {

      if ( $form.find(".webform-confirmation").length ) {

        let assetLink = $form.find("[id=hfFormAsset]").val();

        $form.css({
          'text-align' : 'center',
        });

        $form.append(
          '<a href="' + window.location.origin + assetLink + '" target="_blank">Download</a>'
        )
      }
    });
  }

})(jQuery);
